<template>
<div class="card">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <div class="card-header">
        <p class="card-header-title">Add a Teacher/Supervisor</p>
    </div>
    <div class="card-content">
        
        <b-notification type="is-info" :closable="true" style="padding: 10px; font-size: 12px;">
            <center>Teachers/supervisor may start downloading the app > Login using teacher's email and key in password as 'password'. User can set their own  password inside the app.</center>
        </b-notification>

        <div class="columns">
            <div class="column is-half">
                <input class="input is-success" type="text" placeholder="First Name" v-model="firstName">
            </div>
            <div class="column is-half">
                <input class="input" type="text" placeholder="Last Name" v-model="lastName">
            </div>
        </div>
        <div class="columns">
            <div class="column is-half">
                <input class="input is-success" type="email" placeholder="E-mail" v-model="teacherEmail">
            </div>
            <div class="column is-half vertical-center">
                <strong>This e-mail will be used as the login ID from QR Points app</strong>
            </div>
        </div>

        <div class="columns">
            <div class="column is-full"><button class='button is-primary  is-fullwidth' v-on:click="sendForm()" >Create</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "ManageKelasAdd",
    components:{
        Multiselect,
        Loading,
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            teacherEmail: "",
            isLoading: false,
        };
    },
    created() {
    },
    methods: {
        sendForm() {
            let self = this;

            var firstName = self.firstName;
            var lastName = self.lastName;
            var teacherEmail = self.teacherEmail;

            if (firstName.length < 1){
                Toast.open({
                    message: "Please enter the first name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                firstName = firstName.trim()
            }
            if (!lastName){
                lastName = ""
            }else{
                lastName = lastName.trim()
            }

            if (teacherEmail.length < 5){
                Toast.open({
                    message: "Please enter the first email",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                teacherEmail = teacherEmail.trim()
            }

            self.isLoading = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/add/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                firstName: firstName,
                lastName: lastName,
                teacherEmail: teacherEmail                
            })
            .then(response => {
                self.isLoading = false;
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }

                self.firstName = ""
                self.lastName = ""
                self.teacherEmail = ""
                this.$parent.getData()
            })
            .catch(e => {
                self.isLoading = false;
                console.log(e.response)
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
         
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.vertical-center{
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Teachers/AddContent.vue